import { render, staticRenderFns } from "./ProfileTabs.vue?vue&type=template&id=6e16af9d&"
import script from "./ProfileTabs.vue?vue&type=script&lang=js&"
export * from "./ProfileTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e16af9d')) {
      api.createRecord('6e16af9d', component.options)
    } else {
      api.reload('6e16af9d', component.options)
    }
    module.hot.accept("./ProfileTabs.vue?vue&type=template&id=6e16af9d&", function () {
      api.rerender('6e16af9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/components/ProfileTabs.vue"
export default component.exports